<hc-hygiene-check-evaluation [filterDetails]="config.filterDetails" (childData)=onChildData($event)></hc-hygiene-check-evaluation>